import {isMacOS} from '@github-ui/get-os'
import {testIdProps} from '@github-ui/test-id-props'
import {TriangleDownIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Button, ButtonGroup} from '@primer/react'
import {KeybindingHint} from '@primer/react/experimental'
import type {SyntheticEvent} from 'react'

import {Resources} from '../../strings'
import styles from './save-view-split-button.module.css'

type SaveViewSplitButtonProps = {
  onSave: (event?: SyntheticEvent) => void
  onDuplicate: () => void
  saveButtonText?: string
  disabled?: boolean
  testIdPrefix?: string
}

export function SaveViewSplitButton({
  onSave,
  onDuplicate,
  saveButtonText,
  disabled,
  testIdPrefix = 'save-view-split-button',
}: SaveViewSplitButtonProps) {
  return (
    <ButtonGroup>
      <Button
        variant="primary"
        onClick={onSave}
        disabled={disabled}
        {...testIdProps(`${testIdPrefix}-save-changes-button`)}
      >
        {saveButtonText ?? Resources.saveChanges}
      </Button>
      <ActionMenu>
        <ActionMenu.Button
          className={styles.dropdownButton}
          variant="primary"
          aria-label="More options"
          icon={TriangleDownIcon}
          disabled={disabled}
        />
        <ActionMenu.Overlay side="outside-bottom" align="end">
          <ActionList>
            <ActionList.Item onSelect={event => onSave(event)}>
              {Resources.saveToCurrentView}
              <ActionList.TrailingVisual>
                <KeybindingHint keys={`${isMacOS() ? '⌘' : 'Ctrl'}+S`} />
              </ActionList.TrailingVisual>
            </ActionList.Item>
            <ActionList.Item onSelect={() => onDuplicate()}>{Resources.duplicateView({isDirty: true})}</ActionList.Item>
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </ButtonGroup>
  )
}
